//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por adicionar Tags em Massa no banco de dados via API
export default async function addTagsBulkService (tags) {
  try {
    await api.post("/leads/tags/adicionar", { tags });
    toast.success("Tags aplicadas em massa com sucesso");
    return true;
  } catch (error) {
    toast.error("Erro ao aplicar tags em massa");
    return false;
  }
}